<script>
	import AboutMe from '$lib/components/AboutMe.svelte';
	import PostTimeline from '$lib/components/PostTimeline.svelte';
	import { page } from '$app/stores';

	export let data;

	$: site = $page.data.site;
</script>

<svelte:head>
	<title>{data.content.title}</title>
	<meta name="description" content={data.content.description} />
	<meta property="og:title" content={data.content.title} />
	<meta property="og:description" content={data.content.description} />
	<meta property="og:type" content="website" />
	<meta property="og:url" content="{site.urls.blog}/" />
	<link rel="canonical" href="{site.urls.blog}/" />
</svelte:head>

<main id="main">
	<header class="masthead">
		<div class="container masthead-inner">
			<p class="eyebrow">{data.content.eyebrow}</p>
			<h1>{data.content.heroTitle}</h1>
			<p class="masthead-lead">
				{data.content.description}
			</p>
			<a class="masthead-jump" href="#archive">Browse the archive</a>
		</div>
	</header>

	<PostTimeline posts={data.content.posts ?? []} />
	<AboutMe paragraphs={data.content.aboutParagraphs} name={site.name} />
</main>
